<template>
  <a-modal
    :title="type == 'add' ? '新建合同' : '编辑合同'"
    okText="确定"
    @ok="save"
    v-model="visible"
    :width="650"
  >
    <a-form :form="form" id="contract">
      <a-row :gutter="30">
        <a-col span="25">
          <a-form-item
            label="合同名称"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-input
              v-decorator="[
                'contractname',
                { rules: [{ required: true, message: '请填写合同名称' }] },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="合同类型"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-radio-group
              name="radioGroup"
              @change="changeRadio"
              initialValue="FLASH_INTERVIEW"
              v-decorator="[
                'types',

                { rules: [{ required: true, message: '请选择合同乙方' }] },
              ]"
            >
              <a-radio value="FLASH_INTERVIEW">闪面试</a-radio>
              <a-radio value="TRIAL_ORDER">试单</a-radio>
              <a-radio value="ENTRY">入职</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="合同甲方"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-input
              v-decorator="[
                'company',
                { rules: [{ required: true, message: '请填写合同甲方' }] },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="合同乙方"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-select
              @change="handleChange"
              initialValue="罗高仕管理顾问(青岛)有限公司"
              v-decorator="[
                'client',
                { rules: [{ required: true, message: '请选择合同乙方' }] },
              ]"
            >
              <a-select-option value="罗高仕管理顾问(青岛)有限公司"
                >罗高仕管理顾问(青岛)有限公司</a-select-option
              >
              <a-select-option value="罗科仕科技(北京)股份有限公司"
                >罗科仕科技(北京)股份有限公司</a-select-option
              >
              <a-select-option value="罗高仕科技(北京)股份有限公司"
                >罗高仕科技(北京)股份有限公司</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="合同周期"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-range-picker
              style="display: block"
              format="YYYY-MM-DD"
              v-decorator="[
                'time',
                {
                  rules: [{ required: true, message: '请设置合同周期' }],
                  initialValue: defaultPickerValue,
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="备注"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-textarea
              v-decorator="[
                'introduction',
                { rules: [{ required: false, message: '请填写备注' }] },
              ]"
              placeholder="请填写备注"
              :rows="4"
            />
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item
            label="合同附件"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-upload
              :showUploadList="false"
              v-decorator="[
                'picture',
                {
                  valuePropName: 'file',
                  getValueFromEvent: normFile,
                },
              ]"
              name="file"
              :action="uploadUrl"
              @change="handleUpload"
            >
              <a-button> <a-icon type="upload" />上传 </a-button>
            </a-upload>
            <div class="avatar">
              <a
                style="textdecoration: underline"
                @click="searchContract(routerUrl)"
                >{{ filename }}</a
              >
              <!-- <span>{{ pictureUrl}}</span> -->
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
import moment from "moment";
const baseURL = process.env.VUE_APP_BASEURL;
const columns = [
  {
    title: "文件名",
    dataIndex: "name1",
  },
  {
    title: "上传时间",
    dataIndex: "name2",
  },
  {
    title: "操作",
    dataIndex: "name3",
    scopedSlots: { customRender: "name3" },
  },
];
const listData = [
  {
    id: 0,
    name1: "北京字节跳动科技股份有限公司",
    name2: "已签约",
    name3: "审核通过",
  },
  {
    id: 1,
    name1: "北京字节跳动科技股份有限公司",
    name2: "已签约",
    name3: "审核通过",
  },
  {
    id: 2,
    name1: "北京字节跳动科技股份有限公司",
    name2: "已签约",
    name3: "审核通过",
  },
  {
    id: 3,
    name1: "北京字节跳动科技股份有限公司",
    name2: "已签约",
    name3: "审核通过",
  },
];
export default {
  name: "editCOntract",
  props: ["getList"],
  data() {
    return {
      form: this.$form.createForm(this),
      type: "",
      record: "",
      visible: false,
      columns,
      listData,
      defaultPickerValue: [
        moment().startOf("day").subtract(6, "days"),
        moment().endOf("day"),
      ],
      uploadUrl: baseURL + "/common/file/upload",
      pictureUrl: "",
      routerUrl: "",
      company_id: "",
      logo: "",
      filename: "",
      contractInfo: "",
      doubleTime: "",
    };
  },
  methods: {
    searchContract(fileurl) {
      console.log(fileurl);
      window.open(fileurl, "_blank");
    },
    changeRadio(e) {
      // console.log(e.target.value)
      this.types = e.target.value;
    },
    handleUpload(info) {
      if (info.file.status == "done") {
        // this.pictureUrl = info.file.response.data.url;
        this.logo = info.file.response.data.key;
        this.filename = info.file.response.data.name;
        this.routerUrl = info.file.response.data.url;
      }
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    async save() {
      let moment = require("moment");
      if (this.type === "edit") {
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log(values);
            let params = {
              company_id: this.post_id,
              id: this.contractInfo.id,
              name: values.contractname,
              type: values.types,
              start_date: values.time
                ? moment(values.time[0]).format("YYYY-MM-DD")
                : "",
              end_date: values.time
                ? moment(values.time[1]).format("YYYY-MM-DD")
                : "",
              parta_person_name: values.company,
              partb_person_name: values.client,
              attachment: this.logo,
              attachment_name: this.filename,
              remark: values.introduction,
            };
            console.log(params);
            let res = Api.client.editContract(params);
            console.log(res);
            if (res) {
              this.$message.success("编辑成功");
              this.visible = false;
              this.getList();
            } else {
              this.$message.error("编辑失败");
              this.visible = false;
            }
          }
        });
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log(values);
            let params = {
              company_id: this.post_id,
              name: values.contractname,
              type: values.types,
              start_date: values.time
                ? moment(values.time[0]).format("YYYY-MM-DD")
                : "",
              end_date: values.time
                ? moment(values.time[1]).format("YYYY-MM-DD")
                : "",
              parta_person_name: values.company,
              partb_person_name: values.client,
              attachment: this.logo,
              attachment_name: this.filename,
              remark: values.introduction,
            };
            console.log(params);
            Api.client.addContract(params).then((res) => {
              console.log(res);
              if (res) {
                this.$message.success("添加成功");
                this.visible = false;
                this.getList();
              } else {
                this.$message.error("添加失败");
                this.visible = false;
              }
            });
          }
        });
      }
    },
    handleChange(value) {
      console.log(`selected ${value}`);
      this.secondCompany = value;
    },
    async show(id, post_id) {
      this.visible = true;
      if (this.type === "edit") {
        this.post_id = post_id;
        this.contractInfo = id;
        this.$nextTick().then(() => {
          this.form.setFieldsValue({
            contractname: this.contractInfo.name,
            types: this.contractInfo.type,
            company: this.contractInfo.parta_person_name,
            client: this.contractInfo.partb_person_name,
            introduction: this.contractInfo.remark,
          });
          console.log(this.contractInfo);
          this.defaultPickerValue = [
            moment(this.contractInfo.start_date),
            moment(this.contractInfo.end_date),
          ];
          this.filename = this.contractInfo.attachment_name;
          this.routerUrl = this.contractInfo.attachment_url;
          this.doubleTime = this.contractInfo.start_date;
        });
      } else if (this.type === "add") {
        this.post_id = id;
        console.log(this.post_id);
        this.form.resetFields();
        this.filename = "";
        this.routerUrl = "";
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
#contract {
  #table {
    .delete {
      text-decoration: underline;
    }
    .ant-pagination-disabled {
      display: none !important;
    }
  }
}
</style>
